import React from 'react';
import Icon from '../../../components/AppIcon';
import CategoryCard from './CategoryCard';

const CategorySection = ({ title, icon, categories, onCategoryClick }) => {
  return (
    <div className="space-y-8">
      {/* Section Header */}
      <div className="flex items-center space-x-4">
        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-primary to-primary-600 rounded-xl shadow-soft">
          <Icon name={icon} size={24} color="#FFFFFF" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-text-primary">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary rounded-full mt-2" />
        </div>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {categories?.map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            onCategoryClick={onCategoryClick}
          />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;